import { render, staticRenderFns } from "./CostDistribution.vue?vue&type=template&id=f9ccec5e"
import script from "./CostDistribution.vue?vue&type=script&lang=ts"
export * from "./CostDistribution.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports